import { isBrowser } from "@local/utils/src/isBrowser"
import Cookies from "js-cookie"

export const getTrackingCookies = () => {
  const channelId = isBrowser() ? window.channel : null
  const exponeaId = Cookies.get("__exponea_etc__")
  const fbc = Cookies.get("_fbc")
  const fbp = Cookies.get("_fbp")
  const ga = Cookies.get("_ga")
  const gid = Cookies.get("_gid")
  const googleClickId = Cookies.get("_gcl_aw")
  const gtmUpi = Cookies.get("gtm_upi")
  // INC-841: atob throws on a malformed cookie, and an exception here kills
  // every trackAction dispatch for the session. Degrade to null instead.
  let ip: string | null = null
  const pie = Cookies.get("pie")
  if (pie) {
    try {
      ip = atob(pie)
    } catch {
      // malformed pie, leave null
    }
  }
  const pinterestClick = Cookies.get("_epik")
  const rumbleClickId = Cookies.get("_raclid")
  const sessionId = isBrowser() ? window.$r?.sessionId : null
  const tikTokClickId = Cookies.get("ttclid")
  const vibes = isBrowser()
    ? (window.$vb ??
      window.$r?.vibes ??
      new URL(window.location.href).searchParams.get("vb"))
    : null

  return {
    channelId,
    exponeaId,
    fbc,
    fbp,
    ga,
    gid,
    googleClickId,
    gtmUpi,
    ip,
    pinterestClick,
    rumbleClickId,
    sessionId,
    tikTokClickId,
    vibes,
  }
}
